import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CellValue,
  LimTabDetailsResponse,
  LineItemMonitorMeta,
  LineItemMonitorMetaResponse,
  UpdateLineItemParams,
} from "./line-item-monitor.model";
import { AppService } from "../app.service";

@Injectable({
  providedIn: "root",
})
export class LineItemMonitorDataService {
  apiEP: string = window.apiUrl;
  legacyUrl: string = window.caUrl;
  constructor(
    private http: HttpClient,
    private appService: AppService,
  ) {}

  getLineItemMeta(ticker): Observable<LineItemMonitorMeta> {
    return this.http.get<LineItemMonitorMeta>(
      `${this.apiEP}/monitor/get_lim_meta?ticker=${ticker}`,
    );
  }
  getLIMData(payload): Observable<any> {
    return this.http.post(`${this.apiEP}/monitor/get_lim_data`, payload);
  }

  updateLIMPeriod(payload): Observable<any> {
    return this.http.post(`${this.apiEP}/monitor/update_lim_periods`, payload);
  }

  getFormat(cellValue, isCurrency, unit, formatToLocale): CellValue {
    let obj = new CellValue();
    let displayUnit = "";
    if (isCurrency) {
      displayUnit = unit === "%" ? "%" : "";
    } else {
      displayUnit = unit === "%" ? "bps" : "%";
      // currency = ""; // if it is not currency, then don't show currency symbol
    }

    if (cellValue === "NA") {
      obj = {
        value: cellValue,
        color: "",
      };
    } else {
      let cellValueT = "";
      if (formatToLocale) {
        cellValueT = Math.abs(cellValue).toLocaleString("en-US");
      } else {
        cellValueT = Math.abs(cellValue).toString();
      }
      if (cellValue < 0) {
        obj = {
          value: `(${cellValueT}${displayUnit})`,
          color: "error-color",
        };
      } else {
        if (isCurrency) {
          obj = {
            value: `${cellValueT}${displayUnit}`,
            color: "",
          };
        } else {
          obj = {
            value: `${cellValueT}${displayUnit}`,
            color: "success-color",
          };
        }
      }
    }
    return obj;
  }
  getStdLineItems(reqObj): Observable<LimTabDetailsResponse> {
    return this.http.get<LimTabDetailsResponse>(
      `${this.apiEP}/monitor/get_lim_tab_details`,
      {
        params: reqObj,
      },
    );
  }
  updateLimLines(
    payload: UpdateLineItemParams,
  ): Observable<LineItemMonitorMetaResponse> {
    return this.http.post<LineItemMonitorMetaResponse>(
      `${this.apiEP}/monitor/update_lim_lines`,
      payload,
    );
  }

  getLimDefaultLines(ticker) {
    return this.http.get(`${this.apiEP}/monitor/get_lim_default_lines`, {
      params: { ticker },
    });
  }

  getLineItemLinks(ticker, dapParameterId) {
    return this.http.get(
      `${this.apiEP}/api/get_links_to_nmv_sch/?ticker=${ticker}&cut=NMV&dapparamid=${dapParameterId}`,
    );
  }

  // logDataLoadAction(ticker, dapIds, period) {
  //   this.appService.logUserAction(
  //     {},
  //     ticker,
  //     "NMV",
  //     "MONITORING_PAGE",
  //     {
  //       dapparameterid: dapIds,
  //       period: period
  //     },
  //     "Consensus",
  //     "MONITORING_DATA"
  //   );
  // }
}
